module.exports = __webpack_public_path__ + "assets/images/highlights_logo.209d4ec4190d172ee7499486f912dcca.svg";